import { combineReducers } from "redux";
import { slice } from './mainRedux/mainSlice';

export const rootReducer = combineReducers({
  slice: slice.reducer
});
